import {
  NgModule,
  NO_ERRORS_SCHEMA,
  CUSTOM_ELEMENTS_SCHEMA,
  ApplicationRef
} from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { MatDialogModule } from "@angular/material";
import { FormsModule } from "@angular/forms";
import { CanvasWhiteboardModule } from "ng2-canvas-whiteboard";
import { SlickModule } from 'ngx-slick';

import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { httpInterceptorProviders } from "../../../http-interceptors";

import { ColoringGameComponent } from './components/coloring-the-past/coloring-game/coloring-game.component';
import { ColoringThePastComponent } from './components/coloring-the-past/coloring-the-past.component';
import { ColoringGameDialogComponent } from './components/coloring-the-past/coloring-game-dialog/coloring-game-dialog.component';
import { MummyGameComponent } from './components/mummy-game/mummy-game.component';
import { ChildWorldGamesListingComponent } from './components/child-world-games-listing/child-world-games-listing.component';

import { ChildWorldService } from "./services/child-world.service";
import { MummyGameService } from "./services/mummy-game.service";
import { RelatedContentComponent } from "../../../MainPortalApp/src/app/components/details-listing-components/related-content/related-content.component";
import { InnersSocialMediaSharingComponent } from "../../../MainPortalApp/src/app/components/inners-social-media-sharing/inners-social-media-sharing.component";
import { SharedModule } from "projects/shared/shared.module";

import { Globals } from "projects/shared/models/Globals";
import { GenericListingComponent } from "projects/shared/components/genericListing.component";
import { RelatedProductsComponent } from "projects/MainPortalApp/src/app/components/details-listing-components/related-products/related-products.component";
import { EshopInnerProductListingComponent } from "projects/EshopApp/src/app/components/eshop-inner-product-listing/eshop-inner-product-listing.component";
import { MediaHubComponent } from "projects/MainPortalApp/src/app/components/media-hub-listing/media-hub-listing.component";
import { StoryHubComponent } from "projects/MainPortalApp/src/app/components/story-hub-listing/story-hub-listing.component";
import { MediaPopupComponent } from "projects/shared/components/media-popup/media-popup.component";
import {
	SwiperModule,
	SwiperConfigInterface,
	SWIPER_CONFIG
} from "ngx-swiper-wrapper";
import { IsotopeModule } from "ngx-isotope";
import { NgxMasonryModule } from "ngx-masonry";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MediaGalleryComponent } from "projects/MainPortalApp/src/app/components/details-listing-components/media-gallery/media-gallery.component";
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {};
import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeAr, 'ar');
registerLocaleData(localeFr, 'fr');

declare var targetComponents: any;

@NgModule({
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    HttpClientModule,
    CanvasWhiteboardModule,
    BrowserAnimationsModule,
    MatDialogModule,
    SlickModule.forRoot(),
    InfiniteScrollModule,
    SharedModule,
    CommonModule,
    FormsModule,
    SwiperModule,
    NgbModule,
    IsotopeModule,
    NgxMasonryModule,
  ],
  declarations: [
    GenericListingComponent,
    ColoringThePastComponent,
    ColoringGameComponent,
    ColoringGameDialogComponent,
    MummyGameComponent,
    RelatedContentComponent,
    InnersSocialMediaSharingComponent,
    ChildWorldGamesListingComponent,
    RelatedProductsComponent,
    EshopInnerProductListingComponent,
    MediaHubComponent,
    StoryHubComponent,
    MediaPopupComponent,
    MediaGalleryComponent
  ],
  providers: [    
    Globals,
    ChildWorldService,
    httpInterceptorProviders,
    MummyGameService,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    },
  ],
  entryComponents: [
    ColoringThePastComponent,
    ColoringGameDialogComponent,
    MummyGameComponent,
    RelatedContentComponent,
    InnersSocialMediaSharingComponent,
    ChildWorldGamesListingComponent,
    RelatedProductsComponent,
    EshopInnerProductListingComponent,
    MediaHubComponent,
    StoryHubComponent,
    MediaGalleryComponent
  ]
})
export class AppModule { 
  ngDoBootstrap(appRef: ApplicationRef) {
    if (targetComponents) {
      if (targetComponents.indexOf("app-coloring-the-past") > -1)
        appRef.bootstrap(ColoringThePastComponent);
      if(targetComponents.indexOf("app-mummy-game") > -1)  
        appRef.bootstrap(MummyGameComponent);
      if(targetComponents.indexOf("app-related-content") > -1)  
        appRef.bootstrap(RelatedContentComponent); 
      if(targetComponents.indexOf("app-child-world-games-listing") > -1)  
        appRef.bootstrap(ChildWorldGamesListingComponent);  
      if (targetComponents.indexOf("app-inners-social-media-sharing") > -1)
        appRef.bootstrap(InnersSocialMediaSharingComponent);
      if (targetComponents.indexOf("app-related-products") > -1)
        appRef.bootstrap(RelatedProductsComponent);
      if (targetComponents.indexOf("app-media-hub") > -1)
        appRef.bootstrap(MediaHubComponent);
      if (targetComponents.indexOf("app-story-hub") > -1)
        appRef.bootstrap(StoryHubComponent);
      if (targetComponents.indexOf("app-media-gallery") > -1)
				appRef.bootstrap(MediaGalleryComponent);
    }
  }
}
